// readMore => https://jsramblings.com/2018/02/04/styled-components-media-queries.html
// breakPoints basedOn => https://styleguide.onedev.aok.de/pk/base/breakpoints/

export const generateMediaQueries = (sizes = {}) => {
  const result = {
    max: {},
    min: {},
  }
  Object.keys(sizes).forEach((breakpoint) => {
    result.max[breakpoint] = `(max-width: ${ sizes[breakpoint] - 1 }px)`
    result.min[breakpoint] = `(min-width: ${ sizes[breakpoint] }px)`
  })

  return result
}

/**
 * expand if more breakpoints are required
 * @type {{td: number, xl: number, md: number, sm: number, xs: number, lg: number}}
 */
export const sizes = {
  xs: 544,
  sm: 768,
  md: 992,
  td: 1020, // <-- breakpoint for mobile mode (for main.jx)
  lg: 1216,
  xl: 1440,
}

/**
 * for use in styled component's
 * @type {{min: {}, max: {}}}
 */
export const devices = generateMediaQueries(sizes)
